import React, { useState, Fragment } from "react";
import { connect } from "react-redux";

import { string, func, shape, object, number, bool, any } from "prop-types";

import moment from "moment";

import {
  updateUserInProfileSilent,
  onboardUpdateState,
} from "../redux/actions";

import { getUTCDate, getDateParts } from "../helpers";

import { Validate } from "../common";

import { birthKeys } from "../components/BasicInfo";
import BasicInfoNameView from "../components/BasicInfo/BasicInfoName/index";

import history from "../history";
import { toInt } from "../helpers/helpers";
import { trackOnboardingStep } from "../helpers/productMetrics";

const route = "/onboard/address";

const constraints = {
  year: {
    isDateBefore: {
      date: moment().subtract({ years: 16 }),
      roundUpDay: true,
      keys: birthKeys,
    },
  },
  homeTelephone: {
    isValidTelephone: true,
  },
  mobileTelephone: {
    isValidTelephone: true,
  },
};

const useNameState = (user, appData) => {
  const { birthDay, birthMonth, birthYear } = getDateParts(
    appData.dateOfBirth,
    birthKeys
  );
  const initialState = {
    birthDay,
    birthMonth,
    birthYear,
    homeTelephone: appData.homeTelephone || "",
    mobileTelephone: appData.mobileTelephone || "",
    firstName: appData.firstName || user.givenName,
    lastName: appData.lastName || user.familyName,
    title: appData.title,
    changedItems: {},
    isChanged: false,
  };

  const [state, setState] = useState(initialState);

  const handlers = {
    onPhoneChange: (key, val) => {
      setState((prevState) => ({ ...prevState, [key]: val }));
    },
    onChange: (key, val) => {
      const updatedChangedItems = { ...state.changedItems, [key]: val };
      const newState = {
        ...state,
        [key]: val,
        changedItems: updatedChangedItems,
        isChanged: true,
      };
      setState(newState);
    },
  };

  return [state, handlers];
};

const useOnSubmit = (props) => {
  const {
    title,
    firstName,
    lastName,
    birthDay,
    birthMonth,
    birthYear,
    mobileTelephone,
    homeTelephone,
    appData,
    updateProfile,
    updateOnboardState,
    onboardState,
  } = props;

  const daysInMonth = moment(
    new Date(toInt(birthYear), toInt(birthMonth), 1)
  ).daysInMonth();
  const correctedDay = birthDay === "" ? daysInMonth : birthDay;
  const dateOfBirth = new Date(
    toInt(birthYear),
    toInt(birthMonth),
    toInt(correctedDay)
  );

  const { candidateRef, emailAddress } = appData;
  const utcDate = getUTCDate(dateOfBirth);
  const updatedUserData = {
    candidateRef,
    emailAddress,
    title,
    mobileTelephone: mobileTelephone || appData.mobileTelephone,
    homeTelephone: homeTelephone || appData.mobileTelephone,
    firstName: firstName || appData.firstName,
    lastName: lastName || appData.lastName,
    dateOfBirth: utcDate,
  };
  return () => {
    Promise.all([
      updateProfile(candidateRef, updatedUserData),
      updateOnboardState({ ...onboardState, basic: true }),
      trackOnboardingStep("Basic Information"),
      history.push(route),
    ]);
  };
};

const BasicInfoName = ({
  loading,
  description,
  appData,
  user,
  updateProfile,
  updateOnboardState,
  onboardState,
}) => {
  const [state, handlers] = useNameState(user, appData);
  const {
    title,
    firstName,
    lastName,
    mobileTelephone,
    homeTelephone,
    birthDay,
    birthMonth,
    birthYear,
    isChanged,
  } = state;
  // Create onSubmit handler
  const onSubmit = useOnSubmit({
    appData,
    ...state,
    updateProfile,
    onboardState,
    updateOnboardState,
  });

  const [itemsChanged, setItemChanged] = useState({
    homeTelephone: false,
    mobileTelephone: false,
  });

  const onTelephoneChange = (key, val) => {
    setItemChanged({
      ...itemsChanged,
      [key]: true,
    });
    handlers.onPhoneChange(key, val);
  };
  return (
    <Validate constraints={constraints} userInput={state}>
      {({ validation }) => (
        <Fragment>
          <BasicInfoNameView
            mobileTelephone={mobileTelephone}
            homeTelephone={homeTelephone}
            itemsChanged={itemsChanged}
            onTelephoneChange={onTelephoneChange}
            title={title}
            firstName={firstName}
            lastName={lastName}
            birthDay={birthDay}
            birthMonth={birthMonth}
            birthYear={birthYear}
            description={description}
            isChanged={isChanged}
            validation={validation}
            onSubmit={onSubmit}
            onChange={handlers.onChange}
            loading={loading}
            route={route}
          />
        </Fragment>
      )}
    </Validate>
  );
};

const mapStateToProps = (state) => ({
  user: state.core.user,
  appData: state.core.app,
  description: state.core.umbracoContent.nameSub,
  loading: state.core.loading,
  onboardState: state.core.onboardState,
});
const mapDispatchToProps = {
  updateProfile: updateUserInProfileSilent,
  updateOnboardState: onboardUpdateState,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

BasicInfoName.propTypes = {
  user: object.isRequired,
  appData: shape({
    candidateRef: number.isRequired,
    title: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    dateOfBirth: string.isRequired,
  }),
  description: string.isRequired,
  updateProfile: func.isRequired,
  loading: bool,
  updateOnboardState: func,
  onboardState: any,
};

export default withRedux(BasicInfoName);
